import {useAuthService} from "~/composables/useAuthService";

export default defineNuxtRouteMiddleware(async (to, from) => {
    const {isAuthenticated, user} = useAuthService();
    if(to.meta && to.meta.layout === 'admin' && to.params.clubId && (!isAuthenticated.value || user.value.adminFor.indexOf(to.params.clubId) < 0)){
        return navigateTo('/admin');
    }
    if (!isAuthenticated.value) {
        return navigateTo('/login?authRestricted=true&redirectUrl=' + to.path);
    }
});
